import { useCurrentStateAndParams } from "@uirouter/react";

import type {
    MonitorAndProtectTrademarkParams,
    MonitorAndProtectTrademarkStateDeclaration,
} from "../../app/trademark/routes.types";
import type { ITrademarkFiltersState } from "../../features/trademark-violations/filtres/trademark-filters.types";

export function useMonitorAndProtectTrademarkDataAndParams() {
    const {
        params,
        state,
    }: { params: MonitorAndProtectTrademarkParams; state: MonitorAndProtectTrademarkStateDeclaration } =
        useCurrentStateAndParams();

    const routeQueryParams = {
        trademarkId: (params.trademarkId as string) ?? "",
        duration: (params.duration as string) ?? "28d",
        dataFilters: (params.dataFilters as unknown as Partial<ITrademarkFiltersState>) ?? {},
        sortBy: params.sortBy as string,
        sortDir: params.sortDir as "ascend" | "descend",
    };

    const stateParams = {
        showHeader: state.data?.showHeader ?? true,
        showFilters: state.data?.showFilters ?? true,
        showTrademarkSelector: state.data?.showTrademarkSelector ?? true,
    };

    return {
        ...routeQueryParams,
        ...stateParams,
    };
}
